"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastByIntentComponent = void 0;
var React = require("react");
var pp_react_1 = require("@paypalcorp/pp-react");
var commonUtils_1 = require("../common/utils/commonUtils");
var triggerOperationResult_1 = require("../utils/fpti/triggerOperationResult");
var constants_1 = require("../constants");
var VIEWS = constants_1.default.VIEWS, FPTI = constants_1.default.FPTI;
function handleToastClose(props, obj) {
    if (props.typeOfAction) {
        if (props.typeOfAction !== "remove") {
            commonUtils_1.modifyObjectWithFactor(obj, props.typeOfAction, true, false);
        }
        props.performedAction(null);
    }
}
function createToast(id, message, action, props, obj) {
    triggerOperationResult_1.triggerOperationResult(action, FPTI.SUCCESS, null);
    return (React.createElement(pp_react_1.Toast, { id: id, message: message, isSuccess: true, onClose: function (e) { return handleToastClose(props, obj); }, duration: 6000 }));
}
// TODO: Please make sure that the content keys are kept unique across the features and remove the work around(the contentByTpe variable and add the generic key in this place)
function ToastByIntentComponent(_a) {
    var type = _a.type, content = _a.content, fptiObj = _a.fptiObj, viewType = _a.viewType, props = _a.props, object = _a.object, contentType = _a.contentType;
    var contentByType = "";
    switch (type) {
        case VIEWS[viewType].TOAST_INTENTS.SET_PRIMARY:
            return createToast(type, content.setPrimary.toast, fptiObj.setAsPrimary, props, object);
        case VIEWS[viewType].TOAST_INTENTS.EDIT: {
            contentByType = "edit" + contentType;
            return createToast(type, content[contentByType].toast, fptiObj.edit, props, object);
        }
        case VIEWS[viewType].TOAST_INTENTS.ADD: {
            contentByType = "add" + contentType;
            return createToast(type, content[contentByType].toast, fptiObj.add, props, object);
        }
        case VIEWS[viewType].TOAST_INTENTS.REMOVE: {
            contentByType = "remove" + contentType;
            return createToast(type, content[contentByType].toast, fptiObj.remove, props, object);
        }
        case VIEWS[viewType].TOAST_INTENTS.REMOVE_PRIMARY:
            return createToast(type, content.removePrimary.toast, fptiObj.removePrimary ? fptiObj.removePrimary : fptiObj.remove, props, object);
        case VIEWS[viewType].TOAST_INTENTS.ADD_AS_PRIMARY:
            return createToast(type, content.addPrimary.toast, fptiObj.addPrimary ? fptiObj.addPrimary : fptiObj.add, props, object);
        case VIEWS[viewType].TOAST_INTENTS.UPADTE_PRIMARY:
            return createToast(type, content.setPrimary.toast, fptiObj.editPrimary ? fptiObj.editPrimary : fptiObj.edit, props, object);
        case VIEWS[viewType].TOAST_INTENTS.REMOVE_BILLING_PRIMARY:
            return createToast(type, content.removeBillingPrimary.toast, fptiObj.billing.removeBillingAddressPrimary, props, object);
        case VIEWS[viewType].TOAST_INTENTS.REMOVE_BILLING_PRIMARY_ADD_NEW:
            return createToast(type, content.removeBillingPrimaryAddNew.toast, fptiObj.billing.removeBillingAddressPrimaryAddNew, props, object);
        case VIEWS[viewType].TOAST_INTENTS.REMOVE_BILLING:
            return createToast(type, content.removeBilling.toast, fptiObj.billing.removeBillingAddress, props, object);
        case VIEWS[viewType].TOAST_INTENTS.REMOVE_BILLING_ADD_NEW:
            return createToast(type, content.removeBillingAddNew.toast, fptiObj.billing.removeBillingAddressAddNew, props, object);
        case VIEWS[viewType].TOAST_INTENTS.REMOVE_BILLING_ADD_NEW_PRIMARY:
            return createToast(type, content.removeBillingAddNewPrimary.toast, fptiObj.billing.removeBillingAddressAddNewPrimary, props, object);
        case VIEWS[viewType].TOAST_INTENTS.UPDATE_BILLING_PRIMARY:
            return createToast(type, content.updateBillingPrimary.toast, fptiObj.billing.updateBillingAddressPrimary, props, object);
        case VIEWS[viewType].TOAST_INTENTS.UPDATE_BILLING:
            return createToast(type, content.updateBilling.toast, fptiObj.billing.updateBillingAddress, props, object);
        case VIEWS[viewType].TOAST_INTENTS.UPDATE_BILLING_AS_PRIMARY:
            return createToast(type, content.updateBillingAsPrimary.toast, fptiObj.billing.updateBillingAddressAsPrimary, props, object);
        default:
            return React.createElement(React.Fragment, null);
    }
}
exports.ToastByIntentComponent = ToastByIntentComponent;
